module.exports = __webpack_public_path__ + "img/inspections.c3e759f8.png";